// Auto-generated template cache for Vite
// Loads all HTML templates from views/ and registers them with AngularJS $templateCache

const templates = import.meta.glob('../views/**/*.html', { eager: true, query: '?raw', import: 'default' });

angular.module('templates', []).run(['$templateCache', function($templateCache) {
  Object.entries(templates).forEach(([path, content]) => {
    // Convert path from '../views/foo/bar.html' to 'foo/bar.html'
    const templateUrl = path.replace('../views/', '');
    console.log('Registering template:', templateUrl);
    $templateCache.put(templateUrl, content);
  });
  console.log('Templates registered:', Object.keys(templates).length);
}]);
